import genre from "@/fixtures/dashgo_genres";
import language from "@/fixtures/languages";

const formattedLanguage = Object.assign(
  { na: "N/A", none: "None" },
  Object.values(language).reduce((arr, cur) => {
    arr[cur] = cur;
    return arr;
  }, {})
);

const formattedGenre = Object.assign({ na: "N/A" }, genre);

export default {
  en: {
    base: {
      button: {
        approve: "Approve",
        requestChanges: "Request Changes",
        edit: "Edit",
        reject: "Reject",
        addSong: "Add Song",
        back: "Back",
        reset: "Reset",
        delete: "Delete",
        add: "Add",
        cancel: "Cancel",
        close: "Close",
        flag: "Flag",
        saveEdits: "Save Edits",
        discardEdits: "Discard Edits",
        denyWithSuggestions: "Deny with Suggestions",
        discardSuggestions: "Discard Suggestions",
        update: "Update",
        confirmApproval: "Confirm Approval",
        confirmRejection: "Confirm Rejection"
      }
    },
    release: {
      queue: {
        currentlyReviewingRelease:
          "You have an active review and must compete or discard this review before taking other actions.",
        discardCurrentReviewButton: "Discard Review",
        goToCurrentReviewButton: "Go to Review",
        otherAdminReviwing: "Other Admin Reviewing",
        youAreReviewing: "You Are Reviewing"
      },
      controller: {
        approveButton: "Approve",
        rejectButton: "Reject",
        saveEditsButton: "Save Edits",
        saveCancelButton: "Cancel",
        flagIssuesButton: "Flag Issues",
        confirmApprovalButton: "Confirm Approval",
        confirmRejectionButton: "Confirm Rejection",
        cancelApprovalButton: "Cancel",
        dialogFlagIssuesConfirmButton: "Submit Issues",
        dialogFlagIssuesReturnButton: "Return",
        approvalSuccess:
          "This release has been Approved. The Release will be removed from Submitted List",
        approvalError: "Error Approving release: {fields}",
        flagSuccess:
          "Issues added and User notified. Release will be removed from Submitted List",
        flagError: "Error saving Issues: {fields}",
        editSuccess: "Edits have been saved.",
        editError: "Error saving edits, issue with: {fields}",
        rejectSuccess:
          "This release has been Rejected. Release will be removed from Submitted List",
        rejectError: "Error Rejecting release: {fields}",
        dialogFlagIssuesMessageTitle: "Message to user",
        dialogFlagIssuesMessageRequired:
          "Since no fields have been flagged for suggestions, you must include a message to the user.",
        dialogFlagIssuesMessageOptional: "Optional message to send to the user",
        duplicateLiveSongsCheck:
          "This release has no songs in other Live releases | This release has 1 song in other Live releases. | This release has {count} songs in other Live releases.",
        duplicateSubmittedSongsCheck:
          "This release has no songs in other Submitted releases | This release has 1 song in other Submitted releases. | This release has {count} songs in other Submitted releases.",
        duplicateSongsCheck:
          "This release has no songs in other Releases | This release has 1 song in other Releases. | This release has {count} songs in other Releases.",
        duplicateSongsNamesInReleaseCheck:
          "This release has songs with the same name"
      },
      genre: formattedGenre,
      language: formattedLanguage,
      status: {
        null: "Draft",
        0: "Submitted",
        1: "Live",
        2: "Rejected",
        3: "Awaiting Corrections",
        4: "Approved",
        5: "Hold"
      },
      explicit: { 0: "Clean", 1: "Explicit" },
      detail: {
        magnifyCoverArtCloseButton: "Close",
        featuredArtist: "Featured Artist",
        issueMessage: "Describe Issue",
        editMessage: "Add an edit",
        lyrics: "Lyrics",
        id: "Id",
        language: "Language",
        genre: "Genre",
        albumId: "Id",
        title: "Release Title",
        coverArt: "Cover Art",
        albumTitle: "@:release.detail.title",
        songName: "Song Name",
        play: "Play",
        artistName: "Artist",
        songwriterName: "Song Writer",
        songs: "Songs",
        created: "Created On",
        createdOn: "@:release.detail.created",
        updatedOn: "Updated On",
        royalties: "Royalties",
        user: "User",
        details: "Details",
        search: "Filter User Releases",
        songCount: "Song Count",
        albumCount: "Release Count",
        totalEarnings: "Total Earnings",
        filteredTitle: "User Releases ({count})",
        submittedTitle: "Submitted Releases ({count})",
        reviewStatus: "Review Status",
        submittedOn: "Submitted Date",
        approvedOn: "Approved On"
      },
      tracklist: {
        search: "Search Songs",
        badge: {
          duplicateLiveSongsCheck: "Dupe",
          duplicateSubmittedSongsCheck: "Submitted Dupe",
          duplicateSongsCheck: "ID Dupe",
          duplicateSongsNamesInReleaseCheck: "Name Dupe"
        }
      }
    },
    user: {
      user: "User",
      label: "Label",
      leaveReviewButton: "Back",
      BOOMYUserButton: "Standard",
      BOOMYUserTitle: "Make Standard",
      BOOMYUserMessage: "This will revert the user to the default setting.",
      BOOMYUserConfirmButton: "@:user.BOOMYUserTitle",
      BOOMYUserCancelButton: "Cancel",
      SHADOWBANUserButton: "Shadow Banned",
      SHADOWBANUserTitle: "Shadow Ban",
      SHADOWBANUserMessage:
        "This will Reject all current submissions from this user. Additionally any new submissions they make will automatically be rejected. Are you sure you want to continue, reversing this action will intervention from the development team.",
      SHADOWBANUserConfirmButton: "@:user.SHADOWBANUserTitle",
      SHADOWBANUserCancelButton: "Cancel",
      BULKUserCancelButton: "Cancel",
      BULKUserButton: "Bulk User",
      BULKUserConfirmButton: "@:user.BULKUserTitle",
      BULKUserTitle: "Mark as Bulk",
      BULKUserMessage:
        "This will send all current submissions from this user to our Bulk distributor. Additionally any new submissions they make will automatically be sent to our bulk distributor. Are you sure you want to continue, reversing this action will intervention from the development team.",
      reviewUserSubmissions: "Review Submissions",
      userDetails: "User Details",
      displayName: "Display Name",
      email: "Email",
      uid: "UID",
      dateCreated: "Date Created",
      disabled: "Disabled",
      emailVerified: "Email Verified",
      phoneNumber: "Phone Number",
      lastLogin: "Last Login",
      noUserFound: "No user found."
    }
  }
};
